<ng-container *transloco="let transloco">
  <div class="m-0 flex min-h-screen w-full flex-col lg:grid lg:h-screen lg:grid-cols-[620px_1fr]">

    <nsf-auth-aside
      class="hidden lg:block"
      [eyebrow]="transloco('AUTH.BRAND.EYEBROW')"
      [title]="transloco(loginCopy().asideTitle)"
      [subtitle]="transloco(loginCopy().asideSubtitle)">
    </nsf-auth-aside>

    <div class="flex flex-1 flex-col items-center justify-center gap-10 bg-surface px-6 py-12 lg:px-14 lg:py-10">

      <div class="flex w-full max-w-[420px] flex-col gap-8 md:max-w-[460px] lg:max-w-[420px]">

        <!-- Header -->
        <div class="flex flex-col gap-[22px]">
          <h1 class="m-0 flex items-center gap-3 lg:gap-3.5">
            <img src="/assets/img/nsa-logo.svg" alt="" aria-hidden="true" class="h-9 w-auto lg:h-11">
            <span aria-hidden="true" class="h-[26px] w-px bg-line lg:h-[30px]"></span>
            <span class="text-xl font-bold text-ink-2 lg:text-[22px]">nservices</span>
          </h1>
          <div class="flex flex-col gap-2">
            <p class="m-0 text-2xl font-extrabold text-ink lg:text-[28px]">
              {{ transloco(loginCopy().title) }}
            </p>
            <p class="m-0 text-[15px] leading-[1.5] text-ink-3">
              {{ transloco(loginCopy().subtitle) }}
            </p>
          </div>
        </div>

        @if(loginError(); as loginError) {
          <nsa-alert color="danger" icon="error">
            <div class="flex flex-col gap-1">
              <p class="m-0 text-sm font-bold">{{ transloco(loginCopy().alertTitle) }}</p>
              <p class="m-0 text-[13px] leading-[1.5]">{{ transloco(loginCopy().alertDescription, { support: supportEmail() }) }}</p>
              @if(showCorrelation()) {
                <p class="m-0 pt-2 font-mono text-xs">
                  {{ transloco('LOGIN.ERROR.CORRELATION', { error: loginError.error, correlationId: loginError.correlationId }) }}
                </p>
              }
            </div>
          </nsa-alert>
        }

        <!-- Form -->
        <div class="flex flex-col gap-[18px]">
          <div class="flex flex-col">
            <label for="login-email" class="label label-lg">
              {{ transloco('LOGIN.EMAIL_FIELD.LABEL') }}
              <span class="font-normal text-ink-3">{{ transloco('LOGIN.EMAIL_FIELD.OPTIONAL') }}</span>
            </label>

            <nsa-input-group
              nsaId="login-email"
              size="lg"
              [invalid]="showEmailError()"
              [translatedError]="transloco('LOGIN.EMAIL_FIELD.ERROR')"
              [translatedHint]="transloco('LOGIN.EMAIL_FIELD.HELP')">
              <input
                id="login-email"
                type="email"
                class="input"
                inputmode="email"
                autocomplete="username"
                aria-describedby="login-email-disclaimer"
                [formControl]="emailControl"
                [placeholder]="transloco('LOGIN.EMAIL_FIELD.PLACEHOLDER')"
                (input)="onEmailInput()"
                (keyup.enter)="onContinue()"
                (blur)="onEmailBlur()">
            </nsa-input-group>
          </div>

          <nsa-button
            nsaId="submit-login"
            type="button"
            size="lg"
            className="w-full"
            icon="arrow_forward"
            [disabled]="!canContinue()"
            (click)="onContinue()">
            {{ transloco('LOGIN.ACTION.CONTINUE') }}
          </nsa-button>

          <div class="flex items-center gap-3.5">
            <span class="h-px flex-1 bg-line" aria-hidden="true"></span>
            <span class="text-xs font-bold tracking-[0.14em] text-ink-3">{{ transloco('LOGIN.DIVIDER') }}</span>
            <span class="h-px flex-1 bg-line" aria-hidden="true"></span>
          </div>

          <div class="flex flex-col gap-2">
            <nsa-button
              nsaId="microsoft-login"
              type="button"
              size="lg"
              color="secondary"
              outlined
              className="w-full transition-[background-color,border-color,color]"
              (click)="onMicrosoft()">
              <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true" focusable="false" class="shrink-0">
                <rect width="8" height="8" fill="#F25022" />
                <rect x="10" width="8" height="8" fill="#7FBA00" />
                <rect y="10" width="8" height="8" fill="#00A4EF" />
                <rect x="10" y="10" width="8" height="8" fill="#FFB900" />
              </svg>
              {{ transloco('LOGIN.ACTION.MICROSOFT') }}
            </nsa-button>
            <p class="m-0 text-[13px] leading-[1.5] text-ink-3">
              {{ transloco(loginCopy().microsoftInfo) }}
            </p>
          </div>
        </div>

      </div>

    </div>

  </div>
</ng-container>